import { render, staticRenderFns } from "./Goodslist.vue?vue&type=template&id=491f4cdc&scoped=true&"
import script from "./Goodslist.vue?vue&type=script&lang=js&"
export * from "./Goodslist.vue?vue&type=script&lang=js&"
import style0 from "./Goodslist.vue?vue&type=style&index=0&id=491f4cdc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491f4cdc",
  null
  
)

export default component.exports